<p-toast position="top-right" key="msj"></p-toast>
<p-confirmDialog [style]="{width: '50vw'}" key="kc" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
  rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<p-confirmDialog [style]="{width: '50vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
  rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar" [rejectVisible]="false">
</p-confirmDialog>
<div class="container-fluid" style="border-color: blue; border: 5px ; width: 100%;">
  <div class="row">
    <div class="col-md-12">
      <div class="card card-shadow sinborde">
        <div class="card-header sinborde" style="background: none; ">
          <div class="cardicono rounded">
            <i class="pi pi-history mt-3" style="font-size: 2rem; color: #fff;"></i>
          </div>
          <header style="left: 11%; top: 5%;">Consulta de Movimientos
            <div style="color:blueviolet; display: inline;">Operación Diaria</div>
          </header>

          <div class="row d-flex justify-content-end">
            <div class="form-group  mt-4 mb-1">
              <div class="row  ">
                <div class="d-flex gap-2 mt-3  justify-content-center col-md-7 ">

                  <div class="col-4 row">

                    <div class="col-md-5 d-flex align-items-center">
                      <i class="pi pi-calendar me-2" style="font-size: 1.5rem; color: #3B82F6;"></i>
                      <label class="mb-0 me-2"
                        style="font-weight: 600; font-family: 'Poppins', sans-serif;">Fecha&nbsp;</label>
                    </div>
                    <div class="col-md-7">
                      <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha"
                        tooltipPosition="top" [(ngModel)]="fecha_dia">
                      <hr class="my-0">
                    </div>
                  </div>
                  <div class="col-5 row">
                    <div class="col-md-5 d-flex justify-contend-end align-items-center">
                      <i class="pi pi-calendar me-2" style="font-size: 1.5rem; color: #3B82F6;"></i>
                      <label class="mb-0 me-2"
                        style="font-weight: 600; font-family: 'Poppins', sans-serif;">Fecha&nbsp;Fin&nbsp;</label>
                    </div>
                    <div class="col-sm-7">
                      <input type="date" class="form-control sinborde"
                        pTooltip="Seleccione o teclee fecha fin para filtrar por Rango" tooltipPosition="top"
                        [(ngModel)]="fecha_fin">
                      <hr class="my-0">
                    </div>
                  </div>
                  <div class="col-2 d-flex">
                    <button type="button" (click)="cargarInformacionPorFecha(fecha_dia,fecha_fin);" iconPos="left"
                      class="btn custom-buttoncargar "><i class="pi pi-filter"></i>&nbsp;Filtrar</button>
                  </div>
                </div>


                <div class="d-flex justify-content-start mt-3  col-md-5 ">

                  <div class="col-4 d-flex">
                    <button type="button" class="btn custom-openexcel" (click)="abrirModalReportes()"
                      pTooltip="Abrir Ventana" tooltipPosition="left">
                      <i class="pi pi-arrow-up-right"></i>&nbsp;Reportes
                    </button>
                  </div>
                  <div class="col-4 d-flex ">
                    <button type="button" class="bnt custom-excel" pTooltip="Exportar TODOS los Movimientos a EXCEL"
                      tooltipPosition="right" (click)="exportarExcel();" [disabled]="filtered">
                      <i class="pi pi-file-excel"></i>&nbsp;Exportar
                    </button>
                  </div>
                  <div class="col-4 d-flex ">
                    <button type="button" class="btn custom-excel" pTooltip="Exportar fecha de registro de Recursos"
                      tooltipPosition="right" (click)="exportarExcelRecursos();" [disabled]="this.fecha_dia == null">
                      <i class="pi pi-file-excel"></i>&nbsp;Exportar&nbsp;Recursos
                    </button>


                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <p-table #dt1 [value]="lstMovimientos" [scrollable]="true" scrollHeight="flex" scrollDirection="both"
      [paginator]="true" [rows]="150" [rowsPerPageOptions]="[150,200,300,500]" [showCurrentPageReport]="true"
      currentPageReportTemplate=" {first} a {last} de {totalRecords} Registros"
      [globalFilterFields]="['num_economico','nombre_chofer','num_folio','desc_tipo_aprovechamiento']"
      [loading]="loading">
      <ng-template pTemplate="caption">
        <!-- <div class="flex justify-content-between">
          <button type="button" pButton pRipple class="p-button-success ml-5"
            pTooltip="Exportar TODOS los Movimientos a EXCEL" tooltipPosition="right" (click)="exportarExcel();"
            [disabled]="filtered">
            <i class="pi pi-file-excel">Exportar</i>
          </button>
          <button type="button" pButton pRipple class="p-button-success ml-5"
            pTooltip="Exportar fecha de registro de Recursos" tooltipPosition="right" (click)="exportarExcelRecursos();"
            [disabled]="filtered">
            <i class="pi pi-file-excel">Exportar Recursos</i>
          </button>
          <button type="button" class="btn btn-success" (click)="abrirModalReportes()" pTooltip="Abrir Ventana"
            tooltipPosition="left">
            Reportes <i class="pi pi-file-excel"></i>
          </button>
          <span class="p-input-icon-left p-ml-auto">
            <i class="pi pi-search"></i>
            <input pInputText type="text" size="40" (input)="applyFilterGlobal($event, 'contains')"
              placeholder="Buscar Chofer,Numero Economico,Folio" />
          </span>
        </div>
        <div class="row d-flex justify-content-end mt-5 mb-5">
          <div class="col-md-3">
            <p-columnFilter type="text" field="desc_ruta" placeholder="Ruta" class="form-control sinborde filtro"
              matchMode="contains"></p-columnFilter>
          </div>
          <div class="col-md-3">
            <p-columnFilter type="text" field="desc_cliente" placeholder="Cliente" class="form-control sinborde filtro"
              matchMode="contains"></p-columnFilter>
          </div>
          <div class="col-md-3">
            <p-columnFilter type="text" field="desc_proyecto" placeholder="Proyecto"
              class="form-control sinborde filtro" matchMode="contains"></p-columnFilter>
          </div>
          <div class="col-md-3">
            <p-columnFilter type="text" field="desc_ciudad" placeholder="Ciudad" class="form-control sinborde filtro"
              matchMode="contains"></p-columnFilter>
          </div>

        </div> -->

        <!-- nuevos filtros ---------------------------------->
        <div class="row">
          <!-- Filtros -->
          <div class="col-md-10">
            <div class="row d-flex justify-content-end mt-2  align-items-center">
              <div class="col-md-3">
                <p-columnFilter type="text" field="desc_ruta" placeholder="Ruta" class="form-control sinborde filtro"
                  matchMode="contains"></p-columnFilter>
              </div>
              <div class="col-md-3">
                <p-columnFilter type="text" field="desc_cliente" placeholder="Cliente"
                  class="form-control sinborde filtro" matchMode="contains"></p-columnFilter>
              </div>

              <div class="col-md-3">
                <p-columnFilter type="text" field="desc_ciudad" placeholder="Ciudad"
                  class="form-control sinborde filtro" matchMode="contains"></p-columnFilter>
              </div>

              <div class="col-md-3">

                <div class="p-input-icon-left p-ml-auto mt-1" style="width: 90%; max-width: 400px;">
                  <i class="pi pi-search"></i>
                  <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')"
                    placeholder="Buscar Chofer,Numero Economico,Folio" style="width: 100%;" />
                </div>

              </div>

            </div>
          </div>

          <!-- Botón Limpiar Filtros -->
          <div class="col-md-2 mt-2 d-flex justify-content-start  align-items-center">
            <button class="btn custom-del" (click)="LimpiarFiltro();">
              Limpiar&nbsp;Filtros&nbsp;<i class="pi pi-trash"></i>
            </button>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 100px;">#</th>
          <th style="width: 200px; min-width: 200px;" pSortableColumn="desc_ruta">Ruta<p-sortIcon
              field="desc_ruta"></p-sortIcon></th>
          <th style="width: 300px;" pSortableColumn="desc_tiporuta">Tipo de Ruta<p-sortIcon
              field="desc_tiporuta"></p-sortIcon></th>
          <th style="width: 150px;min-width: 150px;">Ciudad</th>
          <th style="width: 100px;" pSortableColumn="num_economico">#Economico<p-sortIcon
              field="num_economico"></p-sortIcon></th>
          <th style="width: 300px;">Generales</th>
          <th style="width: 120px;min-width: 120px;" pSortableColumn="nombre_chofer">Colaborador<p-sortIcon
              field="nombre_chofer"></p-sortIcon></th>
          <th style="width: 100px;">Fecha</th>
          <th style="width: 200px;" pSortableColumn="clv_fin_ruta"><p-sortIcon field="clv_fin_ruta"></p-sortIcon></th>
          <th style="width: 100;" *ngIf="clv_operacion_fechas == 3"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
        <tr>
          <td style="width: 100px;">{{ (rowIndex+1) }}</td>
          <td style="width: 300px;" [ngClass]="{'col-header-sp': data.clv_especial==1}">{{data.desc_ruta}}
            <p style="display: inline-block; color: green !important;font-weight: bold;">
              {{ data.desc_folio}}</p>
            <p *ngIf="data.clv_especial==2" style="display: inline-block; color: orange !important;font-weight: bold;">
              SIN COBRO</p>
            <p *ngIf="data.clv_especial==3" style="display: inline-block; color: orange !important;font-weight: bold;">
              SIN NOMINA</p>



          </td>
          <td style="width: 300px;" [ngClass]="{'col-header-sp': data.clv_especial==1}">{{data.desc_tiporuta}}
            <p *ngIf="data.clv_cancelado==1" class="col-orange col-md-6 mt-2"
              pTooltip="La ruta se marco como Cancelada por Operaciones">CANCELADA</p>
            <p style="display: inline-block; color: #336b87 !important;font-weight: bold;">
              {{data.desc_tipo_aprovechamiento}}
              <span *ngIf="data.clv_tipo_viaje==1" style="color: #873333 !important;font-weight: bold;">{{data.desc_tipo_viaje}}</span>
            </p>
              
            <!-- <p style="display: inline-block; color: #873333 !important;font-weight: bold;"
              *ngIf="data.clv_tipo_viaje==1">
              {{data.desc_tipo_viaje}}</p> -->
          </td>
          <td style="width: 150px;min-width: 150px;">{{data.desc_ciudad}}</td>
          <td style="width: 100px; color: green; font-weight: bold;">{{data.num_economico}}</td>
          <td style="width: 300px">{{data.datos_generales}}</td>
          <td style="width: 120px;min-width: 120px; color: blueviolet; font-weight: bold; font-size: 10px;">
            <ol>
              <li>{{'(Principal) '+data.nombre_chofer}}</li>
              <li *ngIf="data.id_puesto1!=0">{{'('+data.desc_puesto_adicional1+') '+data.nombre_completo_adicional1}}
              </li>
              <li *ngIf="data.id_puesto2!=0">{{'('+data.desc_puesto_adicional2+') '+data.nombre_completo_adicional2}}
              </li>
            </ol>
          </td>
          <td style="width: 100px;">
            <div>{{data.fecha_registro | date: 'dd/MM/yyyy'}}</div>
            <div class="col-hora text-center">{{data.hora}}</div>
          </td>
          <td style="width: 200px;">
            <div *ngIf="data.clv_operacion==1 || data.clv_operacion==3">
              <div class="d-flex justify-content-center">
                <button type="button" class="btn custom-grey" pTooltip="Recursos" tooltipPosition="top"
                  (click)="mostrarRecursos(data)"><i class="pi pi-eraser"></i>Recursos</button>
              </div>

              <!-- <button type="button"  class="bnt custom-excel"
                      pTooltip="Exportar TODOS los Movimientos a EXCEL" tooltipPosition="right"
                      (click)="exportarExcel();" [disabled]="filtered">
                      <i class="pi pi-file-excel"></i>&nbsp;Exportar
                    </button> -->

              <div class="d-flex justify-content-center mt-2">
                <button type="button" class="btn custom-urea" pTooltip="Gestion de UREA" tooltipPosition="right"
                  (click)="dialogUrea(data)">
                  <i class="pi pi-truck"></i><b>&nbsp;Urea</b></button>
              </div>




            </div>
            <div type="button" class="d-flex justify-content-around mt-2">
              <p-tag *ngIf="data.fecha<=fecha_dia_real && data.clv_fin_ruta==0" severity="warning"
                value="EN TRANSITO"></p-tag>
            </div>
            <div type="button" class="d-flex justify-content-around mt-2">
              <p-tag *ngIf="data.clv_fin_ruta==1" severity="success" value="FINALIZADA"></p-tag>
              <p-tag *ngIf="data.clv_fin_ruta==0" severity="danger" value="NO FINALIZADA"></p-tag>
            </div>
          </td>
          <td style="width: 100px;" *ngIf="clv_operacion_fechas == 3">
            <!-- <div *ngIf="data.clv_operacion==1 || data.clv_operacion==3"> -->
            <div class="d-flex justify-content-center">
              <button class="btn custom-grey" pTooltip="Gestión de Fechas" tooltipPosition="top"
                (click)="mostrarFechasFin(data.idx)"><i class="pi pi-pencil"></i>Fechas</button>
            </div>
            <!-- </div> -->
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>


  <!--ADMINISTRADOR DE RECURSOS-->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dspRecursos" [style]="{width: '95vw','height':'90vh'}"
    [transitionOptions]="'0ms'" styleClass="card-shadow" (onHide)="cancelarModal()">
    <ng-template pTemplate="header">
      <div class="d-flex justify-content-start">
        <div class="col-md-12">Registro de Recursos y Kilometraje de Ruta {{texto_fecha_recurso | date: 'dd/MM/yyyy'}}
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="mt-3">
        <div class="row">
          <div class="col-md-6">
            <p class="d-flex align-items-center" style="font-size: 1.25rem;">
              <span style="color:black;"><b>Número Económico:</b></span>
              &nbsp;
              <span style="color:red;"><b>{{recurso.num_economico}}</b></span>
            </p>
          </div>

        </div>
        <div class="row">
          <div class="col-md-12 texto-lila d-flex justify-content-between ">


            <div class="col-md-6 custom-card-sodexo mr-2">
              <div class="d-flex justify-content-between flex-wrap">

                <div class="info-item">
                  <p><span class="texto-negro">Fijo:</span><span class="texto-azul">
                      {{ num_tag_fijo}}</span></p>
                </div>
                <div class="separator"></div>


                <div class="info-item">
                  <p><span class="texto-negro">Emergente: </span><span class="texto-azul">{{num_tag_emergente}}</span>
                  </p>
                </div>
                <div class="separator"></div>


                <div class="info-item">
                  <p><span class="texto-negro">Sodexo: </span><span class="texto-azul">{{num_tarjeta_sodexo}}</span>
                  </p>
                </div>

              </div>
            </div>





             <!-- <div class=" col-md-8  custom-card-sodexo ml-2 ">
              <div class="row" *ngIf="clv_operacion_fechas != 3">
                <div class="row">
                  <p class="col-md mb-0">{{messageFin}}</p>

                  <div class="d-flex justify-content-center col-md" *ngIf="clv_operacion==1">
                    <button type="button" class="btn custom-sodexo" pTooltip="Gestion de UREA" tooltipPosition="right"
                      (click)="validarInformacionOdometro()"
                      [disabled]="recurso.clv_fin_ruta==1 || btnHabilitarGestion">
                      <b>Finalizar&nbsp;Ruta&nbsp;</b><i class="pi pi-check"></i></button>
                  </div>

                  <div class="col-md" *ngIf="clv_operacion==3">
                    <button type="button" class="btn custom-sodexo" pTooltip="Gestion de UREA" tooltipPosition="right"
                      (click)="validarInformacionOdometro()" [disabled]="btnHabilitarGestion">>
                      <b>Finalizar&nbsp;Ruta&nbsp;</b><i class="pi pi-check"></i></button>

                  </div>
                </div>
              </div>
              <div class="row" *ngIf="clv_operacion_fechas == 3">
                <div class="col-md-6 d-inline justify-content-center">
                  <div class="row">
                    <div class="col-md">
                      <p class="col-md mb-0">{{messageFin}}</p>
                    </div>

                    <div class="col-md" *ngIf="clv_operacion==1">

                      <button type="button" class="btn custom-sodexo" pTooltip="Gestion de UREA" tooltipPosition="right"
                        (click)="validarInformacionOdometro()"
                        [disabled]="recurso.clv_fin_ruta==1 || btnHabilitarGestion">
                        <b>Finalizar&nbsp;Ruta&nbsp;</b> <i class="pi pi-check"></i></button>
                    </div>
                    <div class="col-md" *ngIf="clv_operacion==3">

                      <button type="button" class="btn custom-sodexo" pTooltip="Gestion de UREA" tooltipPosition="right"
                        (click)="validarInformacionOdometro()" [disabled]="btnHabilitarGestion">
                        <b>Finalizar&nbsp;Ruta&nbsp;</b><i class="pi pi-check"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class=" col-md-8 custom-card-sodexo ml-2">
              <div class="row" *ngIf="clv_operacion_fechas != 3">
                <div class="row">
                  <p class="col-md ">{{messageFin}}</p>
                  <div class="col-md" *ngIf="clv_operacion==1">
                    <p-button label="Finalizar Ruta" (onClick)="validarInformacionOdometro()"
                      [disabled]="recurso.clv_fin_ruta==1 || btnHabilitarGestion"></p-button>
                  </div>
                  <div class="col-md" *ngIf="clv_operacion==3">
                    <p-button label="Finalizar Ruta" (onClick)="validarInformacionOdometro()"
                      [disabled]="btnHabilitarGestion"></p-button>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="clv_operacion_fechas == 3">
                <div class="col-md-8 d-inline justify-content-center">
                  <div class="row">
                    <p class="col-md ">{{messageFin}}</p>
                    <div class="col-md" *ngIf="clv_operacion==1">
                      <p-button label="Finalizar Ruta" (onClick)="validarInformacionOdometro()"
                        [disabled]="recurso.clv_fin_ruta==1 || btnHabilitarGestion"></p-button>
                    </div>
                    <div class="col-md" *ngIf="clv_operacion==3">
                      <p-button label="Finalizar Ruta" (onClick)="validarInformacionOdometro()"
                        [disabled]="btnHabilitarGestion"></p-button>
                    </div>
                  </div>
                </div>

              </div>
            </div>







          </div>
        </div>
        <form [formGroup]="dataForm" (ngSubmit)="guardarInformacion()">
          <div class="row">
            <div class="col-md-6">
              <span class="d-flex align-items-center texto-azul-marino mt-2">Información de Recursos de Ruta <i
                  class="pi pi-cog" style="size: 2rem;"></i>
              </span>
            </div>
          </div>
          <div class="col-md-12  d-flex justify-content-between ">
            <!--APARTADO CASETAS-->
            <div class="col-md-5 custom-card-sodexo mr-2 ">
              <div class="row">
                <div class="col-sm-5">
                  <p class="m-0 texto-azul " style="font-size: 1.25rem;">CASETAS</p>
                </div>
                <div class="col-sm-7">
                  <div class="row">
                    <div class="col-md-6">
                      <p class="d-flex align-items-center col-orange">{{messageFinCasetas}}</p>
                    </div>
                    <!-- <div class="col-md-6">
                      <button *ngIf="clv_operacion==1"class="btn custom-fincasetas "
                        (click)="validarInformacionCasetas()"
                        [disabled]="recurso.clv_fin_casetas==1 || btnHabilitarGestion"><b>FinCasetas</b></button>
                      <button *ngIf="clv_operacion==3"  class="btn custom-fincasetas "
                        (click)="validarInformacionCasetas()" [disabled]="btnHabilitarGestion"><b>FinCasetas</b></button>
                    </div> -->
                    <div class="col-md-6">
                      <p-button *ngIf="clv_operacion==1" label="FinCasetas" styleClass="p-button-help"
                        (onClick)="validarInformacionCasetas()"
                        [disabled]="recurso.clv_fin_casetas==1 || btnHabilitarGestion"></p-button>
                      <p-button *ngIf="clv_operacion==3" label="FinCasetas" styleClass="p-button-help"
                        (onClick)="validarInformacionCasetas()" [disabled]="btnHabilitarGestion"></p-button>
                    </div>
                  </div>
                </div>
              </div>
              <!--APARTADO CASETAS-->
              <div class="row mt-2">
                <div class="row mb-1">
                  <div class="col-sm-1 mx-0">
                    <span class="input-group-addon"> <i class="pi pi-align-justify color-icon"
                        style="font-size: 2rem"></i>
                    </span>
                  </div>
                  <div class="col-sm-11">
                    <p-dropdown [options]="lstPagoCaseta" optionLabel="nombre" autoWidth="false"
                      [style]="{'width':'100%'}" placeholder="Seleccione Tipo Pago*" optionValue="id"
                      formControlName="SelectedPagoCaseta"></p-dropdown>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <div class="row g-0">
                    <div class="col-sm-4 mx-0">
                      <span class="input-group-addon"> <i class="pi pi-dollar color-icon"
                          style="font-size: x-small;"></i>
                      </span>
                      <p class="d-inline" style="font-size: x-small;">Caseta</p>
                    </div>
                    <div class="col-sm-8">
                      <input type="number" class="form-control" placeholder="Caseta" formControlName="imp_caseta"
                        style="font-size: x-small;" min="0" pTooltip="Precio Caseta" tooltipPosition="bottom">
                      <hr class="my-0">
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-3">
                  <div class="row g-0">
                    <div class="col-sm-6 mx-0">
                      <p-button icon="pi pi-plus" iconPos="right" (click)="agregarCasetas()" styleClass="p-button-sm"
                        pTooltip="Registrar Caseta"
                        [disabled]="(habilitar_tres_dias && clv_operacion==1) || btnHabilitarGestion || recurso.clv_fin_casetas==1"></p-button>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <p-table #myTab [value]="listCasetas" [tableStyle]="{ 'min-width': '30rem','height':'200px' }"
                      styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex" scrollHeight="200px"
                      [loading]="loading_caseta">
                      <ng-template pTemplate="header">
                        <tr>
                          <th>#</th>
                          <th>Importe</th>
                          <th>Tipo de Pago</th>
                          <th>Info</th>
                          <th></th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
                        <tr *ngIf="data.clv_guardado==0">
                          <td class="col-hora">{{ (rowIndex+1) }}</td>
                          <td>{{ data.imp_caseta | currency }}</td>
                          <td class="texto-lila">{{ data.desc_pago }}
                            <p class="d-inline" style="font-size: 9px;">{{ data.fec_registro | date: 'dd/MM/yyyy' }}</p>
                          </td>
                          <td>
                            <p class="col-orange-sm my-0">
                              Sin guardar
                            </p>
                          </td>
                          <td class="g-0">
                            <p-button icon="pi pi-trash" *ngIf="clv_operacion==1"
                              styleClass="p-button-rounded p-button-warning p-button-text"
                              (onClick)="eliminarCasetas(data)" pTooltip="eliminar local"
                              [disabled]="(data.clv_guardado==1 || btnHabilitarGestion)"></p-button>
                            <p-button icon="pi pi-trash" *ngIf="clv_operacion==3"
                              styleClass="p-button-rounded p-button-warning p-button-text" pTooltip="Admin-local"
                              (onClick)="eliminarCasetas(data)" [disabled]="(btnHabilitarGestion)"></p-button>
                          </td>
                        </tr>
                        <tr *ngIf="data.clv_guardado==1">
                          <td class="col-hora">{{ (rowIndex+1) }}</td>
                          <td>{{ data.imp_caseta | currency }}</td>
                          <td class="texto-lila">{{ data.desc_pago }}
                            <p class="d-inline" style="font-size: 9px;">{{ data.fec_registro | date: 'dd/MM/yyyy' }}</p>
                          </td>
                          <td style="font-size: 9px;">
                            <p pTooltip="Registro" tooltipPosition="left">{{ data.nom_usuario }}</p>
                          </td>
                          <td class="g-0">
                            <p-button icon="pi pi-trash" *ngIf="clv_operacion==1"
                              styleClass="p-button-rounded p-button-danger p-button-text"
                              (onClick)="eliminarCasetas(data)" pTooltip="Info guardada"
                              [disabled]="( btnHabilitarGestion ||
                                !(data.cod_usuario_registro == this.user.cod!
                                && data.fec_registro.toString().substring(0, 10)== this.fecha_hoy.toString().substring(0, 10))
                              )"></p-button>
                            <p-button icon="pi pi-trash" *ngIf="clv_operacion==3"
                              styleClass="p-button-rounded p-button-danger p-button-text" pTooltip="Admin-eliminar"
                              (onClick)="eliminarCasetas(data)" [disabled]="(btnHabilitarGestion)"></p-button>
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="5" style="text-align: center; padding: 2rem;">
                            <i class="pi pi-info-circle" style="font-size: 2rem; color: #888;"></i>
                            <p style="margin-top: 0.5rem; color: #888; font-weight: bold;">Sin Registros</p>
                          </td>
                        </tr>
                      </ng-template>

                    </p-table>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-7 custom-card-sodexo ml-2 "><!--APARTADO COMBUSTIBLE-->
              <div class="row">
                <div class="col-sm-5">
                  <p class="m-0 texto-azul" style="font-size: 1.25rem;">COMBUSTIBLE</p>
                </div>
                <div class="col-sm-7">
                  <div class="row">
                    <div class="col-md-6">
                      <p class="d-flex align-items-center col-orange">{{messageFinCombustible}}</p>
                    </div>
                    <!-- <div class="col-md-6">
                      <button *ngIf="clv_operacion==1" class="btn custom-fincasetas"
                        (onClick)="validarInformacionCombustible()"
                        [disabled]="recurso.clv_fin_combustible==1 || btnHabilitarGestion"><b>FinCombustible</b></button>
                      <button *ngIf="clv_operacion==3" class="btn custom-fincasetas"
                        (onClick)="validarInformacionCombustible()" [disabled]="btnHabilitarGestion"><b>FinCombustible</b></button>
                    </div> -->
                    <div class="col-md-6">
                      <p-button *ngIf="clv_operacion==1" label="FinCombustible" styleClass="p-button-help"
                        (onClick)="validarInformacionCombustible()"
                        [disabled]="recurso.clv_fin_combustible==1 || btnHabilitarGestion"></p-button>
                      <p-button *ngIf="clv_operacion==3" label="FinCombustible" styleClass="p-button-help"
                        (onClick)="validarInformacionCombustible()" [disabled]="btnHabilitarGestion"></p-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="row mb-1">
                  <div class="form-group col-md-6">
                    <div class="row g-0">
                      <div class="col-sm-2 d-flex align-items-center">
                        <span class="input-group-addon"> <i class="pi pi-bars color-icon" style="font-size: 1.5rem"></i>
                        </span>
                      </div>
                      <div class="col-sm-10">
                        <p-dropdown [options]="lstPagoCumbustible" optionLabel="nombre" autoWidth="false"
                          [style]="{'width':'100%'}" placeholder="Seleccione Tipo Pago*" optionValue="id"
                          formControlName="SelectedPagoCombustible"></p-dropdown>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <div class="row g-0">
                      <div class="col-sm-2 d-flex align-items-center">
                        <span class="input-group-addon"> <i class="pi pi-bars color-icon" style="font-size: 1.5rem"></i>
                        </span>
                      </div>
                      <div class="col-sm-10">
                        <p-dropdown [options]="lstCombustible" optionLabel="nombre" autoWidth="false"
                          [style]="{'width':'100%'}" placeholder="Seleccione Combustible*" optionValue="id"
                          formControlName="SelectedTipoCombustible"></p-dropdown>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-4">
                    <div class="row g-0">
                      <div class="col-sm-4 mx-0">
                        <p class="d-inline" style="font-size: x-small;">Litros</p>
                      </div>
                      <div class="col-sm-8">
                        <input type="number" class="form-control" placeholder="Numero de Litros"
                          formControlName="num_litro" style="font-size: x-small;" min="0" pTooltip="Litro">
                        <hr class="my-0">
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <div class="row g-0">
                      <div class="col-sm-4 mx-0">
                        <p class="d-inline" style="font-size: x-small;">Precio</p>
                      </div>
                      <div class="col-sm-8">
                        <input type="number" class="form-control" placeholder="Importe de Litro"
                          formControlName="imp_litro" style="font-size: x-small;" min="0" pTooltip="Precio de Litro">
                        <hr class="my-0">
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <div class="row g-0">
                      <div class="col-sm-4 mx-0">
                        <p class="d-inline" style="font-size: x-small;">Total</p>
                      </div>
                      <div class="col-sm-8">
                        <input type="number" class="form-control" placeholder="Total" formControlName="imp_combustible"
                          style="font-size: x-small;" pTooltip="Total">
                        <hr class="my-0">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="form-group col-md-5">
                    <div class="row g-0">
                      <div class="col-sm-4 mx-0">
                        <p class="d-inline" style="font-size: x-small;">Kim.Inicial</p>
                      </div>
                      <div class="col-sm-8">
                        <input type="number" class="form-control" placeholder="Kim.Inicial"
                          formControlName="kim_inicial_carga" style="font-size: x-small;" min="0" pTooltip="Inicial">
                        <hr class="my-0">
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-5">
                    <div class="row g-0">
                      <div class="col-sm-4 mx-0">
                        <p class="d-inline" style="font-size: x-small;">Kim.Final</p>
                      </div>
                      <div class="col-sm-8">
                        <input type="number" class="form-control" placeholder="Kim.Final"
                          formControlName="kim_final_carga" style="font-size: x-small;" pTooltip="Final">
                        <hr class="my-0">
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <div class="row g-0">
                      <div class="col-sm-12 mx-0">
                        <p-button icon="pi pi-plus" iconPos="right" (click)="agregarCombustible()"
                          styleClass="p-button-sm" pTooltip="Registrar Combustible"
                          [disabled]="(habilitar_tres_dias && clv_operacion==1) || btnHabilitarGestion || recurso.clv_fin_combustible==1"></p-button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <p-table [value]="listCombustible" [tableStyle]="{ 'min-width': '30rem','height':'200px' }"
                      styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex" scrollHeight="200px"
                      [loading]="loading_combustible">
                      <ng-template pTemplate="header">
                        <tr>
                          <th>#</th>
                          <th>Litros</th>
                          <th>Precio</th>
                          <th>Total</th>
                          <th>Pago</th>
                          <th>Km.Inicial</th>
                          <th>Km.Final</th>
                          <th>Recorridos</th>
                          <th>Rendimiento</th>
                          <th>Info</th>
                          <th></th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
                        <tr *ngIf="data.clv_guardado==0">
                          <td class="col-hora">{{ (rowIndex+1) }}</td>
                          <td>{{ data.num_litros_combustible }}</td>
                          <td>{{ data.imp_litro | currency }}</td>
                          <td>{{ data.imp_total_combustible | currency }}</td>
                          <td class="texto-lila">{{ data.desc_pago }}
                            <p class="d-inline" style="font-size: 9px;">{{ data.fec_registro | date: 'dd/MM/yyyy' }}</p>
                          </td>
                          <td>{{ data.kim_inicial_carga | thousand}}</td>
                          <td>{{ data.kim_final_carga | thousand}}</td>
                          <td>
                            <p *ngIf="(data.num_rendimiento!=-1 && data.tipo_combustible!=4)" class="texto-black"> {{
                              data.kim_recorridos | thousand }}</p>
                            <p *ngIf="data.num_rendimiento==-1 || (data.num_rendimiento==0 && data.clv_guardado==0)"
                              class="col-orange-sm my-0">
                              Sin guardar
                            </p>
                          </td>
                          <td>
                            <p *ngIf="(data.num_rendimiento!=-1 && data.tipo_combustible!=4)" class="texto-black"> {{
                              data.num_rendimiento | number:'1.2' }}</p>
                            <p *ngIf="data.num_rendimiento==-1 || (data.num_rendimiento==0 && data.clv_guardado==0)"
                              class="col-orange-sm my-0">
                              Sin guardar
                            </p>
                          </td>
                          <td>
                            <p class="col-orange-sm my-0">
                              Sin guardar
                            </p>
                          </td>
                          <td class="g-0">
                            <p-button icon="pi pi-trash" *ngIf="clv_operacion==1"
                              styleClass="p-button-rounded p-button-warning p-button-text"
                              (onClick)="eliminarCombustible(data)"
                              [disabled]="(data.clv_guardado==1 || btnHabilitarGestion)"
                              pTooltip="Eliminar local"></p-button>
                            <p-button icon="pi pi-trash" *ngIf="clv_operacion==3"
                              styleClass="p-button-rounded p-button-warning p-button-text" pTooltip="Admin-local"
                              (onClick)="eliminarCombustible(data)" [disabled]="(btnHabilitarGestion)"></p-button>
                          </td>
                        </tr>
                        <!--INFORMACIÓN YA ALMACENADA DE LA RUTA-->
                        <tr *ngIf="data.clv_guardado==1">
                          <td class="col-hora">{{ (rowIndex+1) }}</td>
                          <td>{{ data.num_litros_combustible }}</td>
                          <td>{{ data.imp_litro | currency }}</td>
                          <td>{{ data.imp_total_combustible | currency }}</td>
                          <td class="texto-lila">{{ data.desc_pago+'('+data.nom_combustible+')' }}
                            <p class="d-inline" style="font-size: 9px;">{{ data.fec_registro | date: 'dd/MM/yyyy' }}</p>
                          </td>
                          <td>{{ data.kim_inicial_carga | thousand}}</td>
                          <td>{{ data.kim_final_carga | thousand}}</td>
                          <td>{{ data.kim_recorridos | thousand }}</td>
                          <td class="texto-black">{{ data.num_rendimiento | number:'1.2' }}</td>
                          <td style="font-size: 9px; color: brown;">
                            <p pTooltip="Registro" tooltipPosition="left">{{ data.nom_usuario }}</p>
                          </td>
                          <td class="g-0">
                            <p-button icon="pi pi-trash" *ngIf="clv_operacion==1"
                              styleClass="p-button-rounded p-button-danger p-button-text"
                              (onClick)="eliminarCombustible(data)" pTooltip="Info guardada"
                              [disabled]="( btnHabilitarGestion ||
                              !(data.cod_usuario_registro == this.user.cod! &&
                              data.fec_registro.toString().substring(0, 10)== this.fecha_hoy.toString().substring(0, 10)))"></p-button>
                            <p-button icon="pi pi-trash" *ngIf="clv_operacion==3"
                              styleClass="p-button-rounded p-button-danger p-button-text" pTooltip="Admin-eliminar"
                              (onClick)="eliminarCombustible(data)" [disabled]="(btnHabilitarGestion)"></p-button>
                          </td>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="11" style="text-align: center; padding: 2rem;">
                            <i class="pi pi-info-circle" style="font-size: 2rem; color: #888;"></i>
                            <p style="margin-top: 0.5rem; color: #888; font-weight: bold;">Sin Registros</p>
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12  d-flex justify-content-between  mt-5 "> <!--KILOMETRAJE-->
            <div class=" row col-md-6  custom-card-sodexo mr-2">
              <div class="row g-0">
                <div class="col-sm-4 mx-0 ">
                  <span class="input-group-addon  texto-azul-marino">&nbsp;&nbsp;&nbsp;Kim.Inicial<i
                      class="pi pi-map-marker color-icon" style="font-size: 1.5rem"></i>
                  </span>
                </div>
                <div class="col-sm-8">
                  <input type="number" class="form-control" placeholder="Kilometraje Inicial"
                    formControlName="kim_inicial" style="text-transform:uppercase;" min="0"
                    pTooltip="Kilometraje Inicial" tooltipPosition="left">

                </div>
              </div>
            </div>
            <!-- <div class="separator"></div> -->
            <div class=" row col-md-6 custom-card-sodexo ml-2">
              <div class="row g-0">
                <div class="col-sm-4  mx-0">
                  <span class="input-group-addon texto-azul-marino">&nbsp;&nbsp;&nbsp;Kim.Final<i
                      class="pi pi-map-marker color-icon" style="font-size: 1.5rem"></i>
                  </span>
                </div>
                <div class="col-sm-8">
                  <input type="number" class="form-control" placeholder="Kilometraje Final" formControlName="kim_final"
                    style="text-transform:uppercase;" min="0" pTooltip="Kilometraje Final" tooltipPosition="top">

                </div>
              </div>
            </div>
          </div>
          <div class="row d-flex justify-content-center mt-5">
            <div class="col-2">
              <button *ngIf="clv_operacion==1" type="submit" class="btn btn-success w-100"
                [disabled]="(habilitar_tres_dias) || recurso.clv_fin_ruta==1 || btnHabilitar || btnHabilitarGestion"
                pTooltip="Almacenar Toda la Informacion de los Recursos" tooltipPosition="bottom">
                <span class="text-white">Guardar Todo</span>
                <i class="pi pi-save text-white"></i>
              </button>
              <button *ngIf="clv_operacion==3" type="submit" class="btn btn-success w-100"
                pTooltip="Almacenar Toda la Informacion de los Recursos" tooltipPosition="bottom"
                [disabled]="btnHabilitar || btnHabilitarGestion">
                <span class="text-white">Guardar Todo</span>
                <i class="pi pi-save text-white"></i>
              </button>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-2 text-center">
              <i class="pi pi-spin pi-spinner" *ngIf="btnHabilitar"></i>
            </div>
          </div>
        </form>
        <div class="row d-flex justify-content-end mb-5">
          <div class="col-4" *ngIf="mostrar_texto_fechas==1 && habilitar_tres_dias==true && clv_operacion==1">
            <p class="text-justify" style="color: red; font-weight: bold;">*No se pueden editar registros de
              Fechas Anteriores</p>
          </div>
          <div class="col-3">
            <!--<button class="btn btn-warning w-100" (click)="habilitarEdicion();" *ngIf="clv_operacion==1"
                            [disabled]="((fecha_del_recurso<fecha_final_dia && clv_operacion==1) || clv_operacion==1 && recurso.clv_fin_ruta==1)"
                            pTooltip="Habilitar campos para actualizar Información.">
                            <span>Habilitar Edición</span>
                            <i class="pi pi-eraser"></i>
                        </button>-->
            <button class="btn btn-warning w-100" (click)="habilitarEdicion();" *ngIf="clv_operacion==1"
              [disabled]="( (habilitar_tres_dias) || ( recurso.clv_fin_ruta==1))" pTooltip="Habilitar campos."
              tooltipPosition="left">
              <span>Habilitar Edición</span>
              <i class="pi pi-eraser"></i>
            </button>
            <button class="btn btn-warning w-100" (click)="habilitarEdicion();" *ngIf="clv_operacion==3"
              pTooltip="Habilitar campos." tooltipPosition="left">
              <span>Habilitar Edición</span>
              <i class="pi pi-eraser"></i>
            </button>
          </div>
        </div>
        <div class="row d-flex justify-content-start">
          <div class="col-6">
            <p class="texto-black">*Rendimiento=(Kilómetros Recorridos)/Cantidad de litros de la carga.</p>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="cancelarModal();"></button>
    </ng-template>
  </p-dialog>
  <!-----------------------------------REPORTES ITZAEL---------------------------------------->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dbsReportes" [style]="{width: '95vw','height':'785px'}"
    [transitionOptions]="'0ms'" styleClass="card-shadow" (onHide)="cancelarModalReportes()">
    <ng-template pTemplate="header">
      Reportes
    </ng-template>

    <div class="reporteria-container  mt-5 " >
      <section class="reportes-area">
        <div class="card">
          <div class="reportes-grid">
            <div *ngFor="let reporte of reportes" class="reporte-card">
              <h5>
                <i class="pi pi-file-excel" style="font-size: 1.8rem; color: #217346;"></i>
                {{ reporte.titulo }}
              </h5>
              <p class="texto_sm">{{ reporte.descripcion }}</p>

              <div class="row mb-2">
                <!-- Caso especial: Reporte 1 con mes y año -->
                <ng-container *ngIf="reporte.id_reporte === 1; else fechaNormal">
                  <div class="col-4">
                    <p-dropdown [options]="lstCiudades" optionLabel="nombre" [(ngModel)]="reporte.ciudad"
                      placeholder="Ciudad*" [style]="{'width':'100%'}"></p-dropdown>
                  </div>
                  <div class="col-4">
                    <p-dropdown [options]="meses" optionLabel="nombre" [(ngModel)]="reporte.mes" placeholder="Mes*"
                      [style]="{'width':'100%'}"></p-dropdown>
                  </div>
                  <div class="col-4">
                    <p-calendar [(ngModel)]="reporte.anio" view="year" dateFormat="yy" placeholder="Año*"
                      [style]="{'width':'100%'}"></p-calendar>
                  </div>
                </ng-container>

                <!-- Otros reportes con fecha inicio / fin -->
                <!-- <ng-template #fechaNormal>
                  <div [ngClass]="!(reporte.id_reporte === 1) ? 'col-6' : 'col-4'">
                    <input [(ngModel)]="reporte.fec_inicio" type="date" class="form-control sinborde"
                      placeholder="Fecha inicio" />
                  </div>

                  <div *ngIf="(reporte.id_reporte !== 4 )"
                    [ngClass]="!(reporte.id_reporte === 4 || reporte.id_reporte === 1) ? 'col-6' : 'col-4'">
                    <input [(ngModel)]="reporte.fec_fin" type="date" class="form-control sinborde"
                      placeholder="Fecha fin" />
                  </div>

                  <div *ngIf="(reporte.id_reporte === 4 || reporte.id_reporte === 1)"
                    [ngClass]="(reporte.id_reporte === 4 ) ? 'col-6' : 'col-4'">
                    <p-dropdown [options]="lstCiudades" optionLabel="nombre" [(ngModel)]="reporte.ciudad"
                      placeholder="Ciudad*" [style]="{'width':'100%'}"></p-dropdown>
                  </div>
                </ng-template> -->

                <ng-template #fechaNormal>
                  <div *ngIf="this.valPharams(1,reporte.id_reporte)" 
                    [ngClass]="this.valPharams(1,reporte.id_reporte)? 'col-6' : 'col-4'">
                    <input [(ngModel)]="reporte.fec_inicio" type="date" class="form-control sinborde"
                      placeholder="Fecha inicio" />
                  </div>

                  <div *ngIf="this.valPharams(2,reporte.id_reporte)"
                    [ngClass]="!(reporte.id_reporte === 4 || reporte.id_reporte === 1) ? 'col-6' : 'col-4'">
                    <input [(ngModel)]="reporte.fec_fin" type="date" class="form-control sinborde"
                      placeholder="Fecha fin" />
                  </div>

                  <div *ngIf="this.valPharams(3,reporte.id_reporte)" 
                    [ngClass]="(reporte.id_reporte === 4 ) ? 'col-6' : 'col-4'">
                    <p-dropdown [options]="lstCiudades" optionLabel="nombre" [(ngModel)]="reporte.ciudad"
                      placeholder="Ciudad*" [style]="{'width':'100%'}" ></p-dropdown>
                  </div>

                  <div *ngIf="this.valPharams(4,reporte.id_reporte)" 
                    [ngClass]="(reporte.id_reporte === 7 )? 'col-7' : 'col-4'">
                    <p-dropdown [options]="lstCiudadesPri" optionLabel="nombre" [(ngModel)]="reporte.ciudadPrin"
                      placeholder="Todas las Ciudaes*" [style]="{'width':'100%'}" 
                      [filter]="true" filterBy="nombre"
                      [showClear]="true"></p-dropdown>
                  </div>
                  
                </ng-template>

              </div>
             
              <div class="row">
                <div class="col-6 mx-auto">
                  <button class="custom-button w-100"  [disabled]="reporte.btnGenera"
                    (click)="verReporte(reporte.id_reporte, reporte.fec_inicio, reporte.fec_fin, reporte.ciudad, reporte.mes, reporte.anio,reporte.ciudadPrin)">
                    Generar&nbsp;Reporte
                  </button>
                </div>
              </div>
               <div class="p-field">
                <span class="p-input-icon-left">
                  <i class="pi pi-spin pi-spinner" *ngIf="reporte.ldg_rpt"></i>
                </span>
              </div>
            </div>
           
               <!-- <div class="row d-flex justify-content-center">
                <div class="col-2 text-center">
                  <i class="pi pi-spin pi-spinner" *ngIf="botonExcel"></i>
                </div>
              </div> -->  <!-- <div class="row d-flex justify-content-center">
                <div class="col-2 text-center">
                  <i class="pi pi-spin pi-spinner" *ngIf="botonExcel"></i>
                </div>
              </div> -->
          </div>

        </div>
      </section>
    </div>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="cancelarModalReportes();"></button>
    </ng-template>
  </p-dialog>

  <!--REPORTES-->
  <!-- <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dbsReportes" [style]="{width: '70vw','height':'620px'}"
    [transitionOptions]="'0ms'" styleClass="card-shadow" (onHide)="cancelarModalReportes()">
    <ng-template pTemplate="header">
      Reportes
    </ng-template>
    <ng-template pTemplate="content">
      <div class="mt-5">
        <hr class="style-two">
        <div class="row mb-3">
          <div class="col-md-4">
            <p class="texto-pesado">Rendimiento de Unidad Por Colaborador (Mes y Año)</p>
          </div>
          <div class="col-md-2">
            <p-dropdown [options]="lstCiudades" optionLabel="nombre" placeholder="Ciudad*" autoWidth="false"
              [style]="{'width':'100%'}" [showClear]="true" [(ngModel)]="selectedCiudad"
              tooltip="Es la Ciudad a consultar" tooltipPosition="left"></p-dropdown>
            <hr class="my-0">
          </div>
          <div class="col-md-2">
            <p-dropdown [options]="meses" optionLabel="nombre" placeholder="Mes*" autoWidth="false"
              [style]="{'width':'100%'}" [showClear]="true" [(ngModel)]="selectedMesReporte1"
              tooltip="Es el Mes a consultar" tooltipPosition="left"></p-dropdown>
            <hr class="my-0">
          </div>
          <div class="col-md-2">
            <p-calendar [(ngModel)]="anioReporte1" [showIcon]="true" view="year" dateFormat="yy"
              [style]="{'width':'100%'}" placeholder="Seleccione un año*"></p-calendar>
            <hr class="my-0">
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-success" style="width: 100%;" (click)="generarReporte1()">
              Exportar <i class="pi pi-file-export"></i>
            </button>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mt-3 mb-3">
          <div class="col-md-4">
            <p class="texto-pesado">Kilometraje</p>
          </div>
          <div class="col-md-3">
            <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha inicio"
              tooltipPosition="top" [(ngModel)]="fec_dia_reporte">
            <hr class="my-0">
          </div>
          <div class="col-md-3">
            <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha fin"
              tooltipPosition="top" [(ngModel)]="fec_fin_reporte">
            <hr class="my-0">
          </div>
          <div class="col-md-2">

            <button type="button" class="btn btn-outline-success" style="width: 100%;"
              (click)="exportarExcelKilometros(fec_dia_reporte,fec_fin_reporte)" [disabled]="ButtonExportExcel">
              Exportar <i class="pi pi-file-export"></i>
            </button>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mt-3 mb-3">
          <div class="col-md-4">
            <p class="texto-pesado">Movimientos de Operación Diaria</p>
          </div>
          <div class="col-md-3">
            <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha inicio"
              tooltipPosition="top" [(ngModel)]="fec_init_reporte2">
            <hr class="my-0">
          </div>
          <div class="col-md-3">
            <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha fin"
              tooltipPosition="top" [(ngModel)]="fec_fin_reporte2">
            <hr class="my-0">
          </div>
          <div class="col-md-2">

            <button type="button" class="btn btn-outline-success" style="width: 100%;"
              (click)="exportarExcelReporteNuevo(fec_init_reporte2,fec_fin_reporte2)"
              [disabled]="fec_init_reporte2==null">
              Exportar <i class="pi pi-file-export"></i>
            </button>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-2 text-center">
            <i class="pi pi-spin pi-spinner" *ngIf="loading_reporteOperacionDiariaMigrado"></i>
          </div>
        </div>
        <hr class="my-0">
        <div class="row mt-3 mb-3">
          <div class="col-md-4">
            <p class="texto-pesado">Criterio de Colaboradores Asignados(Fecha)</p>
          </div>
          <div class="col-md-3">
            <input type="date" class="form-control sinborde" pTooltip="Seleccione o teclee fecha inicio"
              tooltipPosition="top" [(ngModel)]="fec_init_asignacion">
            <hr class="my-0">
          </div>
          <div class="col-md-3">
            <p-dropdown [options]="lstCiudades" optionLabel="nombre" placeholder="Ciudad*" autoWidth="false"
              [style]="{'width':'100%','height':'70%'}" [showClear]="true" [(ngModel)]="selectedCiudadAsignacion"
              tooltip="Es la Ciudad a consultar" tooltipPosition="left"></p-dropdown>
            <hr class="my-0">
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-success" style="width: 100%;"
              (click)="exportarExcelReporteAsignacion()"
              [disabled]="fec_init_asignacion==null||selectedCiudadAsignacion.id==0||btnRptAsign">
              Exportar <i class="pi pi-file-export"></i>
            </button>
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div class="col-2 text-center">
            <i class="pi pi-spin pi-spinner" *ngIf="loading_reporteAsignacionColab"></i>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="cancelarModalReportes();"></button>
    </ng-template>
  </p-dialog>
 -->
  <!----------------------------- DIALOG DE GESTION DE FECHAS ------->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="dgfechas" [style]="{'width': '72vw','height':'70vh'}"
    [transitionOptions]="'0ms'" styleClass="card-shadow" (onHide)="cancelarGestionFechas()">
    <ng-template pTemplate="header">
      Gestor de Fechas: {{desc_ruta}}
    </ng-template>
    <ng-template pTemplate="content">
      <div class="row card card-shadow sinborde mt-5">
        <!-- <div class="card card-shadow sinborde mt-5"> -->
        <form [formGroup]="formfechas" (ngSubmit)="guardarFechas()">
          <div class="row btnGrp">
            <div class="d-colResp bd-higlight mb-3">
              <div class="col">
                <label for="lblligero" class="col-sm-6 col-form-label color-font text-right"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                  <span class="input-group-addon"> <i class="pi pi-calendar
                                            color-icon mr-3" style="font-size: 2rem; color: #3B82F6;"></i>
                  </span>
                  Registro Servicio</label>
              </div>
              <div class="col">
                <input type="datetime-local" class="form-control sinborde" formControlName="fecha"
                  pTooltip="Seleccione o teclee fecha" tooltipPosition="top">
                <hr class="my-0">
              </div>
            </div>
          </div>
             <!-- <div class=" col-md-4">
                    <label class="fw-bold mb-1 d-block ml-2" style="font-size: 12px; color: black;"><b>Fecha y
                        Hora:</b></label>
                    <input type="datetime-local" id="fecha-dia" formControlName="fecha" class="p-inputtext"
                      style="width: 100%; font-weight: bold; color: black;" style="width: 100%;"
                      [ngClass]="{ 'p-filled': formCombustible.get('fecha')?.value }" />
                  </div> -->
          <div class="row btnGrp mb-3 ml-5">
            <div class="col d-resp">
              <div>
                <label for="lblligero" class="col-sm-12 col-form-label color-font text-right"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                  <span class="input-group-addon"> <i class="pi pi-truck color-icon mr-3"
                      style="font-size: 2rem; color: #3B82F6;"></i>
                  </span>
                  Fin Combustible
                </label>
              </div>
              <div>
                <input type="datetime-local" class="form-control sinborde" formControlName="fecha_fin_combustible"
                  pTooltip="Seleccione o teclee fecha" tooltipPosition="top">
                <hr class="my-0">
              </div>
            </div>
            <div class="col d-resp">
              <div>
                <label for="lblligero" class="col-sm-12 col-form-label color-font text-right"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                  <span class="input-group-addon"> <i class="pi pi-building color-icon mr-3"
                      style="font-size: 2rem; color: #3B82F6;"></i>
                  </span>
                  Fin Casetas</label>
              </div>
              <div>
                <input type="datetime-local" class="form-control sinborde" formControlName="fecha_fin_casetas"
                  pTooltip="Seleccione o teclee fecha" tooltipPosition="top">
                <hr class="my-0">
              </div>
            </div>
            <div class="col d-resp">
              <div>
                <label for="lblligero" class="col-sm-12 col-form-label color-font text-right"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                  <span class="input-group-addon"> <i class="pi pi-check-circle color-icon mr-3"
                      style="font-size: 2rem; color: #3B82F6;"></i>
                  </span>
                  Fin Ruta</label>
              </div>
              <div>
                <input type="datetime-local" class="form-control sinborde" formControlName="fecha_fin_ruta"
                  pTooltip="Seleccione o teclee fecha" tooltipPosition="top">
                <hr class="my-0">
              </div>
            </div>
            <div class="col d-resp">
              <div>
                <label for="lblligero" class="col-sm-12 col-form-label color-font text-right"
                  style="font-weight: 600; font-family: 'Poppins', sans-serif;">
                  <span class="input-group-addon"> <i class="pi pi-check-circle color-icon mr-3"
                      style="font-size: 2rem; color: #3B82F6;"></i>
                  </span>
                  Fin Operaciones</label>
              </div>
              <div>
                <input type="datetime-local" class="form-control sinborde" formControlName="fecha_fin_operacion"
                  pTooltip="Seleccione o teclee fecha" tooltipPosition="top">
                <hr class="my-0">
              </div>
            </div>
          </div>
          <div class="row justify-content-center mb-2">
            <div class="col-2 ">
              <button type="submit" class="btn btn-success w-100" [disabled]="!formfechas.valid || !formfechas.dirty"
                pTooltip="Modificar Fechas" tooltipPosition="left">
                <span class="text-white">Guardar Todo</span>
                <i class="pi pi-save text-white"></i>
              </button>
            </div>
          </div>
        </form>
        <!-- </div> -->
        <!-- <div class="row d-flex justify-content-center">
                <div class="col-2 text-center">
                    <i class="pi pi-spin pi-spinner" *ngIf="loading_fechas"></i>
                </div>
            </div> -->
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="cancelarGestionFechas();"></button>
    </ng-template>
  </p-dialog>



  <!------------------------------------ dialog de urea --------------------------------->
  <!--ADMINISTRADOR DE RECURSOS-->
  <p-dialog [resizable]="false" [draggable]="false" [(visible)]="openDialogUrea"
    [style]="{width: '80vw','height':'100vh'}" [transitionOptions]="'0ms'" styleClass="card-shadow"
    (onHide)="cancelarUreaOperaciones()">
    <ng-template pTemplate="header">
      <div class="d-flex justify-content-start">
        <div class="col-md-12">Registro de Recursos de UREA
          <!-- {{texto_fecha_recurso | date: 'dd/MM/yyyy'}} -->
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="mt-1">

        <form [formGroup]="formCombustible" (ngSubmit)="guardarUreaOperaciones(1, 0)">
          <div class="row">
            <div class="col-md-6">
              <span class="texto-azul-marino">Información de Recursos de Ruta <i class="pi pi-cog"
                  style="size: 2rem;"></i>
              </span>
            </div>
          </div>

          <div class="custom-card">
            <div class="d-flex justify-content-between flex-wrap">

              <div class="info-item">
                <p><span class="texto-negro">Folio de ruta: </span><span class="texto-azul-marino">{{
                    formCombustible.controls['desc_folio'].value }}</span></p>
              </div>

              <div class="separator"></div>

              <div class="info-item">
                <p><span class="texto-negro">Número Económico: </span><span class="texto-azul-marino">
                    {{ this.formCombustible.controls['num_economico'].value }}</span></p>
              </div>

              <div class="separator"></div>

              <div class="info-item">
                <p><span class="texto-negro">Placa: </span><span class="texto-azul-marino">{{
                    formCombustible.controls['desc_placaUnidad'].value }}</span></p>
              </div>

              <div class="separator"></div>

              <div class="info-item">
                <p><span class="texto-negro">Ciudad: </span><span class="texto-azul-marino">{{
                    formCombustible.controls['desc_ciudad'].value }}</span></p>
              </div>

            </div>
          </div>
          <div class="row mt-2">
            <div class="d-flex justify-content-center">
              <span class="texto-azul" style="font-size: 20px;">Agregar nuevo <i class="pi pi-plus"
                  style="size: 2rem;"></i>
              </span>
            </div>
          </div>


          <div class="custom-card mt-1">
            <div class="row align-items-end">
              <!-- Inputs (10 columnas) -->
              <div class="col-md-12">
                <div class="row">

                  <div class=" col-md-4">
                    <label class="fw-bold mb-1 d-block ml-2" style="font-size: 12px; color: black;">
                      Proveedor*</label>
                    <p-dropdown inputId="id_proveedor" [options]="lstProvedores" optionLabel="proveedor"
                      [styleClass]="'placeholder-bold'" optionValue="id_proveedor" formControlName="id_proveedor"
                      [style]="{ minWidth: '100%', width: '100%' }" placeholder="Seleccione un Proveedor">
                    </p-dropdown>
                  </div>
                  <div class=" col-md-4">
                    <label class="fw-bold mb-1 d-block ml-2" style="font-size: 12px; color: black;">Tipo de
                      Combustible*</label>
                    <p-dropdown inputId="estatus2" [options]="lstCombustibleUrea" optionLabel="nombre" optionValue="id"
                      [styleClass]="'placeholder-bold'" formControlName="id_combustible"
                      [style]="{ minWidth: '100%', width: '100%' }" placeholder="Seleccionar el Tipo de
                      Combustible">
                    </p-dropdown>
                  </div>


                  <div class=" col-md-4">
                    <label class="fw-bold mb-1 d-block ml-2" style="font-size: 12px; color: black;"><b>Fecha y
                        Hora:</b></label>
                    <input type="datetime-local" id="fecha-dia" formControlName="fecha" class="p-inputtext"
                      style="width: 100%; font-weight: bold; color: black;" style="width: 100%;"
                      [ngClass]="{ 'p-filled': formCombustible.get('fecha')?.value }" />
                  </div>
                </div>



                <div class="row mt-3">
                  <div class="p-float-label mt-2 col-md-4">
                    <input (input)="calcularTotalUrea()" id="nombre" type="number" pInputText
                      formControlName="num_litros_urea" class="form-control   fw-bold " />
                    <label for="nombre" style="font-weight: bold;">&nbsp;Litros*</label>
                  </div>
                  <div class="p-float-label mt-2 col-md-4">
                    <input (input)="calcularTotalUrea()" id="nombre" type="number" pInputText
                      formControlName="imp_litro_urea" class="form-control fw-bold " />
                    <label for="nombre" style="font-weight: bold;">&nbsp;Precio por Litro:</label>
                  </div>


                  <div class="p-float-label mt-2 col-md-4">
                    <input id="nombre" type="text" pInputText formControlName="imp_total_urea"
                      class="form-control   fw-bold " />
                    <label for="nombre" style="font-weight: bold;">&nbsp;Total</label>
                  </div>

                </div>
                <div class="row mt-3">

                  <div class="p-float-label mt-2 col-md-4">
                    <input id="nombre" type="number" pInputText formControlName="kim_inicial"
                      class="form-control fw-bold" />
                    <label for="nombre" style="font-weight: bold;">&nbsp;Kim.Inicial:</label>
                  </div>
                  <div class="p-float-label mt-2 col-md-4">
                    <input id="nombre" type="number" pInputText formControlName="kim_final"
                      class="form-control fw-bold" />
                    <label for="nombre" style="font-weight: bold;">&nbsp;Kim.Final:</label>
                  </div>

                  <div class="col-md-4 d-flex align-items-center  justify-content-center mt-2">
                    <!-- agregar disable -->
                    <button type="submit" class="btn btn-primary" [disabled]="!habilitar_tres_dias_urea"
                      pTooltip="Guardar Registro" tooltipPosition="left">
                      <span class="text-white"><b>Guardar&nbsp;</b></span>
                      <i class="pi pi-save text-white"></i>
                    </button>
                  </div>


                </div>
              </div>

            </div>
          </div>

          <div class="row mt-2">
            <div class="d-flex justify-content-center">
              <span class="texto-azul" style="font-size: 20px;">Consulta
              </span>
            </div>
          </div>

          <div class="custom-card-tabla mt-1">
            <div class="row mt-3">
              <div class="col-md-12">
                <p-table #myTab [value]="listCasetass" [tableStyle]="{ 'min-width': 'relative','height':'relative' }"
                  styleClass="p-datatable-sm" [scrollable]="true" scrollHeight="flex" scrollHeight="relative"
                  [loading]="loading_urea">

                  <ng-template pTemplate="header">
                    <tr>
                      <th>#</th>
                      <th>Litros</th>
                      <th>Proveedor</th>
                      <th>Fecha</th>
                      <th></th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-data let-rowIndex="rowIndex">
                    <tr>
                      <td class="col-hora">{{ (rowIndex+1) }}</td>
                      <td>{{ data.num_litros_urea }}</td>
                      <td class="texto-azul-marino">{{ data.desc_provedor }}
                        <!-- <p class="d-inline" style="font-size: 9px;">{{data.desc_provedor}}</p> -->
                      </td>
                      <td style="font-size: 14px;">
                        <p pTooltip="Registro" tooltipPosition="left"><b>{{ data.fecha | date: 'dd/MM/yyyy hh:mm a'
                            }}</b></p>
                      </td>
                      <td class="g-0">
                        <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger p-button-text"
                          (onClick)="guardarUreaOperaciones(2, data.idx)" pTooltip="Info guardada"
                          [disabled]="!habilitar_tres_dias_urea"></p-button>

                      </td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="5" style="text-align: center; padding: 2rem;">
                        <i class="pi pi-info-circle" style="font-size: 2rem; color: #888;"></i>
                        <p style="margin-top: 0.5rem; color: #888; font-weight: bold;">Sin Registros</p>
                      </td>
                    </tr>
                  </ng-template>

                </p-table>
              </div>
            </div>
          </div>



        </form>


      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
        (click)="cancelarUreaOperaciones();"></button>
    </ng-template>
  </p-dialog>
</div>
